import {
  WSIcon,
  WSIconSize,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { useVersionQuickReferenceModal } from "../../RequirementDefinitions/components/VersionQuickReferenceModal";
import React from "react";

export const RequirementVersionLabel: React.FC<{
  requirementDefinitionId: string;
  version?: number;
  defaultSecondaryText?: React.ReactNode;
  size?: "S" | "M";
}> = ({
  requirementDefinitionId,
  version,
  defaultSecondaryText,
  size = "S"
}) => {
  const versionQuickReferenceModal = useVersionQuickReferenceModal();
  const versionText = version && version > 1 ? `v${version}` : undefined;

  const secondaryTextString = [defaultSecondaryText, versionText]
    .filter(Boolean)
    .join(" ");

  const color = size === "S" ? "gray500" : "gray600";

  return secondaryTextString ? (
    <WSList.Horizontal alignItems="center" gap="XS">
      <WSText kind={size === "S" ? "ParagraphXs" : "ParagraphSm"} color={color}>
        {secondaryTextString}
      </WSText>
      <WSIcon
        name="info-circle-fill"
        color={color}
        size="S"
        onClick={() =>
          versionQuickReferenceModal.open({
            requirementDefinitionId
          })
        }
      />
    </WSList.Horizontal>
  ) : null;
};
